module.exports = __webpack_public_path__ + "static/media/covid-19.9591c39a.png";